
import { RevInputText } from '@ds/components/InputText'
import { RevSlider } from '@ds/components/Slider'
import debounce from 'debounce'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import Graph from '../Graph/Graph.vue'

import translations from './VisualPrice.translations'

const DELAY = 200
const INPUT_NAME = 'Input'
const SLIDER_NAME = 'Slider'

export default {
  components: {
    RevSlider,
    Graph,
    RevInputText,
  },

  props: {
    minSelected: {
      type: Number,
      default: 0,
    },
    maxSelected: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      minRange: this.minSelected,
      maxRange: this.maxSelected,
      minInput: this.minSelected,
      maxInput: this.maxSelected,
    }
  },

  computed: {
    translations: () => translations,

    ...mapGetters({
      values: 'landingSearch/values',
      range: 'landingSearch/range',
    }),

    currency() {
      return this.$t.currencySign()
    },

    labelRange() {
      return [
        this.$t(translations.minPrice, { currency: this.currency }),
        this.$t(translations.maxPrice, { currency: this.currency }),
      ]
    },

    hasValues() {
      return !isEmpty(this.values)
    },
  },

  watch: {
    minSelected(newMinSelected) {
      const newMinInt = parseInt(newMinSelected, 10)
      this.minRange = newMinInt
      this.minInput = newMinInt
    },

    maxSelected(newMaxSelected) {
      const newMaxInt = parseInt(newMaxSelected, 10)
      this.maxRange = newMaxInt
      this.maxInput = newMaxInt
    },
  },

  methods: {
    updateRange(value) {
      this.minRange = value[0]
      this.maxRange = value[1]

      this.minInput = value[0]
      this.maxInput = value[1]

      this.debounceRange(value, SLIDER_NAME)
    },

    updateInputMin({ target }) {
      let { value } = target
      value = parseInt(value, 10)

      if (value >= this.min && value <= this.max && value <= this.maxInput) {
        this.minInput = value
        this.minRange = value
      } else {
        this.minInput = this.min
        this.minRange = this.min
      }
      this.sendPrice([this.minInput, this.maxInput], INPUT_NAME)
    },

    updateInputMax({ target }) {
      let { value } = target
      value = parseInt(value, 10)

      if (value >= this.min && value <= this.max && value >= this.minInput) {
        this.maxInput = value
        this.maxRange = value
      } else {
        this.maxInput = this.max
        this.maxRange = this.max
      }
      this.sendPrice([this.minInput, this.maxInput], INPUT_NAME)
    },

    debounceRange: debounce(function debouncePrice(value, name) {
      this.sendPrice(value, name)
    }, DELAY),

    sendPrice(value, name) {
      this.$emit('change', { value, name })
    },
  },
}
